import { Epic, ofType } from "redux-observable";
import { RootState } from "../../store";
import * as authSelectors from "../auth/authSelectors";
import * as countryActions from "./countryActions";
import { ServiceContainer } from "../../serviceContainer";
import { of } from "rxjs";
import { catchError, exhaustMap, map } from "rxjs/operators";

export const countryListEpic: Epic<any, any, RootState, ServiceContainer> = (
  action$,
  state$,
  services
) =>
  action$.pipe(
    ofType(countryActions.LIST_COUNTRIES),
    exhaustMap((action: countryActions.ListCountriesAction) => {
      const state = state$.value;

      return services.apiCountry.listAll(authSelectors.accessToken(state)).pipe(
        map((countries) => countryActions.listCountriesSuccess(countries)),
        catchError(() => {
          services.toastr.error(
            "Countries fetch fail",
            "There was error while fetching country list"
          );
          return of(countryActions.listCountriesFail());
        })
      );
    })
  );
